export default __webpack_public_path__ + "static/yoga-banner-b761afc217e918632247065ddf1e00a0.jpg";